import store from '@/store';
export default function guard(to, from, next) {
    // Retrieve information about authentication from store
    // Check if user can pass pages requiring authentication
    var predicate = store.getters['auth/auth'] == true;
    // Define redirect for users that are authenticated
    // Authenticated users can proceed to dashboard
    var redirect = function () { return next({ name: 'dashboard' }); };
    // If check returns true, user can be redirect
    // Otherwise, user will be show the indented site
    return predicate ? redirect() : next();
}
;
